import { cn } from '@cobliteam/ui/utils';
import { Reorder } from 'motion/react';
import type React from 'react';

export interface DraggableListProps {
  children: React.ReactNode;
  onReorder: (newOrder: any[]) => void;
  className?: string;
  values: any[];
}

const DraggableList = ({ children, onReorder, className, values }: DraggableListProps) => {
  return (
    <Reorder.Group axis='y' values={values} onReorder={onReorder} className={cn(className)} as='div'>
      {children}
    </Reorder.Group>
  );
};

export default DraggableList;
